import React, { useEffect, useState } from 'react';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import AnchorIcon from '@mui/icons-material/Anchor';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import LocalAirportIcon from '@mui/icons-material/LocalAirport';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import moment from 'moment';

interface props {
    data: {
        EstimatedDepartureDate: Date;
        EstimatedArrivalDate: Date;
        DestPort_City: string;
        DestPort_CodeCity: string;
        DestPort_CodeCountry: string;
        DestPort_Country: string;
        OrigPort_City: string;
        OrigPort_CodeCity: string;
        OrigPort_CodeCountry: string;
        OrigPort_Country: string;
        TypeShipment: string;
        VesselName: string;
        FlightNumber:string;
        CarrierPRONumber:string;
    };
    title?: string;
    textXs?: string;
}

const SteeperHeaderSH = ({ data, title,textXs}: props) => {
    const {
        EstimatedDepartureDate,
        EstimatedArrivalDate,
        DestPort_City,
        DestPort_CodeCity,
        DestPort_CodeCountry,
        DestPort_Country,
        OrigPort_City,
        OrigPort_CodeCity,
        OrigPort_CodeCountry,
        OrigPort_Country,
        TypeShipment,
        VesselName,
        FlightNumber,
        CarrierPRONumber

    } = data;

    const [percentage, setPercentage] = useState(1);
    const [date, setDates] = useState({ initial: '', final: '' });

    const calcularPorcentajeTranscurrido = (fechaInicio: Date, fechaFin: Date) => {
        const inicio = new Date(fechaInicio);
        const fin = new Date(fechaFin);
        const hoy = new Date();

        const diferenciaTotal = fin.getTime() - inicio.getTime();

        const diferenciaHoy = hoy.getTime() - inicio.getTime();

        const porcentaje = (diferenciaHoy / diferenciaTotal) * 100;
        const response = Math.round(porcentaje * 100) / 100;

        return response > 100 ? 100 : response < 1 ? 1 : response;
    };

    const iconTypeShipment = () => {
        switch (TypeShipment) {
            case 'AirShipment':
                return <LocalAirportIcon className="iconTransportShipment" />;
            case 'OceanShipment':
                return <DirectionsBoatIcon className="iconTransportShipment" />;
            case 'GroundShipment':
                return <LocalShippingIcon className="iconTransportShipment" />;
            default:
                return <ViewInArIcon className="iconTransportShipment" />;
        }
    };

    useEffect(() => {
        setPercentage(calcularPorcentajeTranscurrido(EstimatedDepartureDate, EstimatedArrivalDate));
        const initial = moment(EstimatedDepartureDate);
        const final = moment(EstimatedArrivalDate);
        const formattedDate = initial.format('MM/DD/YYYY');
        const formattedDateF = final.format('MM/DD/YYYY');
        setDates({
            initial: formattedDate,
            final: formattedDateF,
        });
    }, []);

    return (
        <div style={{fontSize:`${textXs ? textXs:"auto"}`}} className="SteeperHeaderSHContainer">
            {title && <span>{title}</span>}
            <div>
                <div className="infoPortSteeper">
                    <div style={{ alignItems: 'end' }}>
                        <p>{`${OrigPort_CodeCountry || ''}${OrigPort_CodeCity || ''}`}</p>
                        <p>{date.initial}</p>
                    </div>
                    <span>
                        <WarehouseIcon />
                    </span>
                    <div>
                        <p style={{fontSize:`${textXs ? textXs:"auto"}`}} className='CityInfoSteeper'>{OrigPort_City || ''}</p>
                        <p>{OrigPort_Country || ''}</p>
                    </div>
                </div>

                <div className="routeStepper">
                    <span
                        style={{
                            position: 'absolute',
                            left: '0%',
                            transform: `translateX(-${'0'}%)`,
                            padding: '1px',
                            border: '#999999 1px solid',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                        }}
                    >
                        {/* <AnchorIcon style={{ width: '20px', height: '20px' }} /> */}
                    </span>

                    <span
                        style={{
                            position: 'absolute',
                            left: `${Math.max(percentage, 0)}%`,
                            transform: `translateX(-${percentage}%)`,
                            padding: '4px',
                            border: '#999999 1px solid',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            transition: '3s',
                            zIndex: '2',
                            textAlign: 'center',
                            display: 'inline-block',
                        }}
                    >
                        {iconTypeShipment()}
                        <p
                            style={{
                                position: 'absolute',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                whiteSpace: 'nowrap',
                                paddingTop: '5px',
                                fontSize:`${textXs ? textXs:"auto"}`
                            }}
                        >
                            {TypeShipment === "OceanShipment" ? VesselName : (TypeShipment === "AirShipment" ? FlightNumber :CarrierPRONumber) || ''}
                        </p>
                    </span>

                    <span
                        style={{
                            position: 'absolute',
                            left: '100%',
                            transform: `translateX(-${'100'}%)`,
                            padding: '1px',
                            border: '#999999 1px solid',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                        }}
                    >
                        {/* <AnchorIcon style={{ width: '20px', height: '20px' }} /> */}
                    </span>
                </div>

                <div className="infoPortSteeper">
                    <div style={{ alignItems: 'end' }}>
                        <p style={{fontSize:`${textXs ? textXs:"auto"}`}} className='CityInfoSteeper'>{DestPort_City || ''}</p>
                        <p>{DestPort_Country || ''}</p>
                    </div>
                    <span>
                        <WarehouseIcon />
                    </span>
                    <div>
                        <p>{`${DestPort_CodeCountry || ''}${DestPort_CodeCity || ''}`}</p>
                        <p>{date.final}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SteeperHeaderSH;
